import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import { Auth } from "aws-amplify";
import { Authentication } from "../context/AuthenticationContext";
//df logo
import logo from "../images/logo.png";
import { withFormik } from "formik";
import * as yup from "yup";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loggingIn: false,
      failed: false,
      message: "",
      allowLogin: false,
      validateCalled: false
    };
  }

  async componentDidMount() {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: false
      });
      const valid = user.getSignInUserSession().isValid();
      if (valid) {
        console.log("there is a user");
        return this.props.history.push("/dashboard");
      }
    } catch (err) {
      console.log(err);
      this.setState({ allowLogin: true });
    }
  }

  handleChange = name => e => {
    this.setState({ [name]: e.target.value });
  };

  onSignin = async onSigninMethod => {
    try {
      if (!this.state.validateCalled) this.setState({ validateCalled: true });
      if (this.state.message) this.setState({ message: "" });
      await this.props.validateForm();
      if (this.props.isValid) {
        let { email, password } = this.props.values;
        let user = await Auth.signIn({
          username: email,
          password: password,
          validationData: {
            medium: "web"
          }
        });
        let isAuthenticated;
        if (user.challengeName) {
          onSigninMethod(user, isAuthenticated);
          this.props.history.push("/new-password/" + user.username);
          isAuthenticated = false;
        } else {
          onSigninMethod(user, isAuthenticated);
          isAuthenticated = true;
          this.props.history.push("/dashboard");
        }
      } else {
        this.setState({ loggingIn: false });
      }
    } catch (err) {
      let message;
      if (err.code === "UserLambdaValidationException") message = "You are not allowed to login here";
      else message = err.message;
      this.setState({
        failed: true,
        loggingIn: false,
        message: message,
        password: ""
      });
      console.log(err);
    }
  };

  onFormSubmit = (e, onSigninMethod) => {
    console.log("hello there");
    e.preventDefault();
    this.setState({ loggingIn: true });
    this.onSignin(onSigninMethod);
  };

  render() {
    const { validateCalled } = this.state;
    const { handleChange, handleBlur, errors, values, touched, isValidating } = this.props;
    return (
      <Authentication.Consumer>
        {context => {
          return (
            <div>
              {this.state.allowLogin ? (
                <React.Fragment>
                  <div
                    style={{
                      width: 350,
                      position: "absolute",
                      left: "50%",
                      marginLeft: -175,
                      top: "50%",
                      marginTop: -304
                    }}
                  >
                    <Paper style={{ marginBottom: 20 }}>
                      {this.state.loggingIn ? <LinearProgress variant="indeterminate" color="primary" style={{ height: 2 }} /> : null}
                      <div style={{ padding: "20px 30px 60px" }}>
                        <div style={{ textAlign: "center" }}>
                          <img src={logo} height={180} style={{ display: "inline-block" }} alt="" />
                        </div>
                        <Typography variant="h4" style={{ textAlign: "center", fontWeight: 300, fontWeight: "400" }}>
                          Sign in
                        </Typography>
                        <Typography variant="h6" style={{ textAlign: "center", fontWeight: 300 }}>
                          Please enter the required fields.
                        </Typography>
                        <Typography variant="subtitle1" style={{ color: "#e74c3c", fontStyle: "italic" }} component="span">
                          {this.state.message}
                        </Typography>
                        <form onSubmit={e => this.onFormSubmit(e, context.onSignin)}>
                          <TextField
                            label="Email"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            autoComplete="off"
                            type="email"
                            id="email"
                            value={values.email}
                            helperText={(touched.email || validateCalled) && errors.email}
                            error={(touched.email || validateCalled) && errors.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ width: "100%", fontSize: "80px" }}
                            variant="outlined"
                          />
                          <TextField
                            label="Password"
                            type="password"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            id="password"
                            value={values.password}
                            helperText={(touched.password || validateCalled) && errors.password}
                            error={(touched.password || validateCalled) && errors.password}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ width: "100%", fontSize: "80px" }}
                            variant="outlined"
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between"
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ cursor: "pointer" }}
                              component="span"
                              onClick={() => this.props.history.push("/forgot-password")}
                            >
                              Forgot password?
                            </Typography>
                            <Tooltip title="You need to ask Dentistfind administration to create the account for you." placement="top">
                              <Typography variant="subtitle1" component="span" color="primary" style={{ cursor: "pointer" }}>
                                No account?
                              </Typography>
                            </Tooltip>
                          </div>

                          <Button style={{ marginTop: 40 }} variant="contained" color="primary" type="submit" size="large" fullWidth>
                            Sign in
                          </Button>
                        </form>
                      </div>
                    </Paper>
                    <h5
                      style={{
                        bottom: 0,
                        color: "#636e72",
                        textAlign: "center",
                        margin: "4px"
                      }}
                    >
                      Built by the Web Development Team
                    </h5>
                    <h5
                      style={{
                        bottom: 0,
                        color: "#636e72",
                        textAlign: "center",
                        margin: "4px"
                      }}
                    >
                      &copy; DentistFind Inc.
                    </h5>
                  </div>
                </React.Fragment>
              ) : (
                <LinearProgress color="primary" style={{ height: 2 }} />
              )}
            </div>
          );
        }}
      </Authentication.Consumer>
    );
  }
}

export default withFormik({
  mapPropsToValues: props => {
    return {
      email: "",
      password: ""
    };
  },
  validationSchema: yup.object().shape({
    password: yup.string().required("Password is a required field!"),
    email: yup
      .string()
      .email("Please provide a valid email address!")
      .required("Email address is a required field!")
  }),
  enableReinitialize: true,
  validateOnChange: true
})(Login);
